import { GET_APPLICATIONS_LIST_BRANCHWISE, TEAM_OVERVIEW_ERROR, TEAM_OVERVIEW_LOADING } from "../actionType";

let initialState = {
    loading: false,
    error: null,
    branchwiseApplicationsList: {
        metaData: {
            total_application_count: 0,
            in_progress_count: 0,
            completed_count: 0,
            reject_count: 0,
        },
        application_stage_breakdown: {},
        officer_wise_breakdown: []
    },
};

export const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case TEAM_OVERVIEW_LOADING:
            return {
                ...state,
                loading: true,
                error: null,
            };
        case TEAM_OVERVIEW_ERROR:
            return {
                ...state,
                loading: false,
                error: payload,
            };
        case GET_APPLICATIONS_LIST_BRANCHWISE:
            return {
                ...state,
                loading: false,
                branchwiseApplicationsList: { 
                    metaData: {
                        total_application_count: payload?.total_application_count,
                        in_progress_count: payload?.in_progress_count,
                        completed_count: payload?.completed_count,
                        reject_count: payload?.reject_count,
                    },
                    application_stage_breakdown: payload?.application_stage_breakdown,
                    officer_wise_breakdown: payload?.officer_wise_breakdown
                },
                error: null,
            };
 
        default:
            return state;
    }
};
